
const getGalleryImages = (data) => {
  return data.map((item) => {
    return item;
  });
};

export default getGalleryImages;
